import React, { useState, useEffect } from "react";
import { Layout, Menu, Card } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose1 from "../../Assets/Tool/pose.jpg";
import { API_BASE_URL } from "../../Config";
import axios from "axios";
import dummyImg from "../../Assets/dummyImg.jpg";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;

const Meditation = () => {
  const [selectedKey, setSelectedKey] = useState("home");
  const [allYogaPages, setAllYogaPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/allpages?page=meditations`,
        );
        const json = await res.data;
        setAllYogaPages(json?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getDynamicPageContent = (key) => {
    if (key === "home") {
      const home = allYogaPages.find((p) => p.yogaType === "Yoga Main Page");

      if (home) return home.content;

      return `
  <h2 style="text-align:center; font-size:30px; margin-bottom:10px;">
  What is Meditation?
</h2>

<p style="max-width:800px; margin:0 auto 25px; text-align:center; line-height:1.7; font-size:16px;">
  Amidst the chaotic demands of modern life, finding peace of mind is a challenge.
  Meditation is a mental practice that focuses the mind on a specific state and calms the mind.
  It is also an achievement that can be used to develop our inner power.
  It is not related to any religion, but a life skill that everyone can learn.
  It is an art that has been practiced in Eastern countries, including India, for thousands of years.
</p>

<ul style="max-width:800px; margin:0 auto 30px; line-height:1.8; font-size:16px;">
  <li>To achieve peace and tranquility.</li>
  <li>To become aware of the constant flow of thoughts in the mind and get rid of them.</li>
  <li>To develop self-awareness.</li>
  <li>To improve focus.</li>
  <li>To reduce stress.</li>
</ul>

<h3 style="color:#005b88; margin-top:25px;">Types of Meditation:</h3>

<h4 style="margin-top:15px;">Focus Meditation</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Focusing on the breath</li>
  <li>Chanting a mantra/word</li>
  <li>Looking at a candle flame</li>
</ul>

<h4 style="margin-top:15px;">Mindfulness</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Living in the present moment</li>
  <li>Noticing thoughts (but not getting caught up in them)</li>
</ul>

<h4 style="margin-top:15px;">Love-Kindness Meditation</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Developing love for yourself and others</li>
  <li>Thinking "May all beings live happily"</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Benefits of Meditation:</h3>

<h4>For the mind:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Reduced stress</li>
  <li>Increased focus and memory</li>
  <li>Control of thoughts</li>
  <li>Peace and contentment</li>
</ul>

<h4 style="margin-top:15px;">For the body:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Reduced blood pressure</li>
  <li>Increased immunity</li>
  <li>Relief from insomnia</li>
  <li>Delayed aging</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Simple Meditation Method (Beginner Level):</h3>

<p style="font-size:16px; margin-bottom:10px;"><b>Place:</b> Choose a quiet place</p>
<p style="font-size:16px; margin-bottom:10px;"><b>Position:</b> Sit in Sukhasana / Padmasana</p>
<p style="font-size:16px; margin-bottom:10px;"><b>Eyes:</b> Closed or half-closed</p>
<p style="font-size:16px; margin-bottom:10px;"><b>Back:</b> Keep your back straight</p>

<h4 style="margin-top:15px;">Steps:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Take 5 deep breaths and exhale</li>
  <li>Notice the natural inflow and outflow of your breath</li>
  <li>Focus on your nostrils / chest / lungs</li>
  <li>If thoughts come, bring them back to your breath</li>
  <li><b>Start:</b> 5–10 minutes a day</li>
  <li><b>Then:</b> Gradually increase the time</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Key Principles:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li>Don't control your thoughts — just observe</li>
  <li>There is no such thing as "failure" in meditation</li>
  <li>Fatigue is natural</li>
  <li>Meditation is for the experience, not for the goal</li>
</ul>

<h3 style="color:#005b88; margin-top:25px;">Common Mistakes:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li>Expecting "the mind to be quiet"</li>
  <li>Expecting results too quickly</li>
  <li>Irregular practice</li>
  <li>Forcing a meditative state</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Scientific Aspects of Meditation:</h3>

<h4 style="margin-top:15px;">Changes in the Brain:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>Amygdala</b> (fear/stress center) — shrinks</li>
  <li><b>Prefrontal cortex</b> (decision-making center) — thickens</li>
  <li><b>Serotonin</b> (happiness hormone) — increases</li>
  <li><b>Cortisol</b> (stress hormone) — decreases</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Benefits in Daily Life:</h3>

<h4 style="margin-top:15px;">In Work / Study:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Increase in attention span</li>
  <li>Improvement in problem-solving skills</li>
  <li>Creative thinking</li>
  <li>Decision-making skills</li>
</ul>

<h4 style="margin-top:15px;">In Relationships:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Increase in patience</li>
  <li>Anger control</li>
  <li>Ability to understand other people's feelings</li>
  <li>Improvement in communication skills</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Advanced Meditation Methods:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>Vipassana meditation</b> — observing body sensations</li>
  <li><b>Sotan meditation</b> — seeing the natural light of the mind</li>
  <li><b>Drasakam</b> — focusing on external objects without closing the eyes</li>
  <li><b>Natham meditation</b> — focusing on internal sounds</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Tools to Help with Meditation:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>Malais / Jabamala</b> — to hold attention</li>
  <li><b>Mantras</b> — "Om", "Sam", "Amma"</li>
  <li><b>Nature sounds</b> — rain, waterfall, birdsong</li>
  <li><b>Brush / Sandal</b> — mind-calming fragrance</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">7 Steps of Meditation:</h3>
<ol style="line-height:1.8; font-size:16px;">
  <li><b>Asana</b> — Steady, comfortable posture</li>
  <li><b>Pranayama</b> — Regulating breathing</li>
  <li><b>Pratyakara</b> — Focusing the senses</li>
  <li><b>Dharana</b> — Focusing attention</li>
  <li><b>Dhyana</b> — Continuous flow of attention</li>
  <li><b>Samadhi</b> — Union status</li>
  <li><b>Kevalam</b> — Natural state</li>
</ol>

<h3 style="color:#005b88; margin-top:30px;">Daily Tips:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>Morning:</b> 10–15 minutes (to start the day)</li>
  <li><b>Noon:</b> 5 minutes (to relieve fatigue)</li>
  <li><b>Evening:</b> 10 minutes (to end the day)</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Daily Meditation Routine:</h3>

<h4 style="margin-top:15px;">Morning:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Wake up and take a bath</li>
  <li>Pranayama (15 minutes)</li>
  <li>Meditation (15–30 minutes)</li>
</ul>

<h4 style="margin-top:15px;">Evening:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Savasana / Rest (15 minutes)</li>
  <li>Meditation (15–30 minutes)</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">5 Golden Rules of Meditation:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>Releasing</b> — Don't hold on to thoughts</li>
  <li><b>Attention</b> — You are not the thoughts, you are the observer</li>
  <li><b>Reflection</b> — Focus on the breath repeatedly</li>
  <li><b>Don't force it</b> — Let it come naturally</li>
  <li><b>Thankfulness</b> — Give thanks after each meditation</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Points of Focus in Meditation:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>Tip of the nose</b> — Sensation of the breath coming and going</li>
  <li><b>Between the eyebrows</b> — Anjali Chakra</li>
  <li><b>Navel</b> — Manipura Chakra</li>
  <li><b>Heart</b> — Anahata Chakra</li>
  <li><b>Mantra</b> — "Om", "So Hum", "Amma"</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Experiences During Meditation:</h3>

<h4 style="margin-top:15px;">Normal Experiences:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Feeling of lightness in the body</li>
  <li>Warmth/coldness in the hands and feet</li>
  <li>Slight dizziness</li>
  <li>Feeling of the body swinging</li>
</ul>

<h4 style="margin-top:15px;">Advanced Experiences:</h4>
<ul style="line-height:1.8; font-size:16px;">
  <li>Lost sense of time and space</li>
  <li>A sense of peaceful bliss</li>
  <li>Seeing light/colors</li>
  <li>A sense of unity</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Solutions to Challenges:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>"No time"</b> — Start with just 5 minutes</li>
  <li><b>"No mind"</b> — That's the purpose of meditation!</li>
  <li><b>"Rapid thoughts"</b> — Let them come and go like clouds</li>
  <li><b>"Physical discomfort"</b> — You can do it sitting in a chair</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Meditation for Children:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>"Balloon Breath"</b> — Like blowing up a balloon with your breath</li>
  <li><b>"My heartbeat"</b> — Notice physical sensations</li>
  <li><b>"Sending love"</b> — Imagine love for living beings</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Special Meditation Techniques:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li><b>"I am not" Meditation</b> — "Who am I?" Asking</li>
  <li><b>Laughter Meditation</b> — Laugh for 5 minutes</li>
  <li><b>Walking Meditation</b> — Paying attention while walking</li>
  <li><b>Meal Meditation</b> — Paying full attention while eating</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Modern Meditation Apps:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li>Headspace</li>
  <li>Calm</li>
  <li>Insight Timer</li>
  <li>Guided meditation (YouTube / Spotify)</li>
  <li>Phone reminder notifications — help you meditate consistently</li>
</ul>

<h3 style="color:#005b88; margin-top:30px;">Important Facts:</h3>
<ul style="line-height:1.8; font-size:16px;">
  <li>There is no "win-lose" in meditation</li>
  <li>Every meditation is a different experience</li>
  <li>Expecting results will not bring results</li>
  <li>Continued practice will bring results</li>
  <li>Meditation is a skill that can grow throughout life</li>
  <li>Start at your own pace!</li>
</ul>
`;
    }

    const page = allYogaPages.find((p) => p._id === key);
    return page?.content || "<p>No content found.</p>";
  };

  const menuItems = [
    ...allYogaPages.map((p) => ({
      key: p._id,
      label: p.yogaType,
    })),
    { key: "home", label: "Back to Main Page" },
  ];

  const selectedContent = (
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: getDynamicPageContent(selectedKey) }}
    />
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        className="responsive"
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          className="sub_slider"
          width={250}
          style={{
            height: "900px", // 👈 decrease height here
            backgroundImage: `url(${pose1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Explore Meditation 
          </div>

          <Menu
            theme="white"
            mode="inline"
            style={{
              background: "transparent",
              color: "#ffffffA2",
              fontSize: "1.1rem",
              position: "relative",
              zIndex: 2,
              fontWeight: 500,
              textAlign: "center",
            }}
            itemStyle={{ color: "#fff" }}
            onClick={(e) => setSelectedKey(e.key)}
            selectedKeys={[selectedKey]}
            items={menuItems}
          />
        </Sider>
        <Content
          className="content_responsive"
          style={{ padding: "30px", flex: 1 }}
        >
          <div
            style={{
              display: "flex",
              gap: "32px",
              alignItems: "flex-start",
            }}
          >
            <div style={{ flex: 1 }}>
              {loading ? (
                <h2>Loading...</h2>
              ) : (
                <div>
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={selectedKey}
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.4 }}
                    >
                      <Card
                        className="inner_card"
                        style={{ borderRadius: "12px", padding: "24px" }}
                      >
                        {selectedContent}
                      </Card>
                    </motion.div>
                  </AnimatePresence>
                </div>
              )}
            </div>

            {/* RIGHT SIDE AD */}
          </div>
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default Meditation;
